import { useEffect, useMemo, useState } from 'react'
import {
  IonContent,
  IonHeader,
  IonLabel,
  IonPage,
  IonSearchbar,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
} from '@ionic/react'
import FamilyListItem from '../components/FamilyList'
import { Family, getFamily, getFamilyMeta } from '../data/family'
import familyPic from './familia.jpg'

import './Home.css'

const Home: React.FC = () => {
  const [families, setFamilies] = useState<Family[]>([])
  const [filterType, setFilterType] = useState<string>('all')
  const [query, setQuery] = useState<string>('')

  const { membersCount, vaccinatedCount } = useMemo(() => {
    return getFamilyMeta()
  }, [])

  const isFiltering = useMemo(() => query !== '' || filterType !== 'all', [
    query,
    filterType,
  ])

  useEffect(() => {
    const fmly = getFamily(query, filterType === 'vaccinated')
    setFamilies(fmly)
  }, [query, filterType])

  return (
    <IonPage id="home-page">
      <IonHeader>
        <IonToolbar>
          <IonTitle>{vaccinatedCount} de {membersCount} vacinados!</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="avatar">
          <img src={familyPic} />
        </div>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>Os Galinhas D'água</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonSearchbar
          placeholder="Buscar por nome"
          value={query}
          onIonChange={(e) => setQuery(e.detail.value!)}
        ></IonSearchbar>

        <div className="family-filter">
          <IonSegment
            value={filterType}
            onIonChange={() =>
              setFilterType(filterType === 'all' ? 'vaccinated' : 'all')
            }
          >
            <IonSegmentButton value="all">
              <IonLabel>Todos</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="vaccinated">
              <IonLabel>Vacinados</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </div>
        {families.map((family) => (
          <FamilyListItem
            key={family.name}
            family={family}
            isFiltered={isFiltering}
          />
        ))}
      </IonContent>
    </IonPage>
  )
}

export default Home
